import { Store } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Props {
  title?: string;
  message?: string;
  actionLabel?: string;
}

const EmptyCashSessionState: React.FC<Props> = ({
  title = "Sesión de Caja",
  message = "No hay una sesión activa. Debes abrir una caja para comenzar a registrar movimientos en el sistema.",
  actionLabel = "Abrir Caja",
}) => {
  const navigate = useNavigate();

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      {/* HEADER */}
      <div className="flex items-center gap-3 px-6 py-5 border-b border-stroke dark:border-strokedark">
        
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">
          <Store size={20} />
        </div>

        <div>
          <h4 className="font-medium text-black dark:text-white">
            {title}
          </h4>
          <p className="text-sm text-gray-500">
            Estado de la caja
          </p>
        </div>

      </div>

      {/* BODY */}
      <div className="px-6 py-8 text-center">

        <p className="mx-auto mb-6 max-w-md text-sm text-gray-500 dark:text-gray-400">
          {message}
        </p>

        <button
          onClick={() => navigate("/cash/opening")}
          className="
            inline-flex items-center justify-center gap-2
            rounded-sm bg-primary px-6 py-2.5
            text-sm font-medium text-white
            shadow-sm transition
            hover:bg-primary/90 hover:shadow-md
            active:scale-[0.98]
          "
        >
          {actionLabel}
        </button>

      </div>

    </div>
  );
};

export default EmptyCashSessionState;